import React from "react";
import { motion } from "framer-motion";
import {
  Search,
  ClipboardList,
  Lightbulb,
  Rocket,
  BarChart3,
  RefreshCw,
  type LucideIcon,
} from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

type Step = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

const steps: Step[] = [
  { number: "01", title: "Discovery & Audit", description: "Analyze your brand, competitors, and current digital presence.", icon: Search },
  { number: "02", title: "Strategy Planning", description: "Define goals, target audience, channels, and campaign roadmap.", icon: ClipboardList },
  { number: "03", title: "Creative Development", description: "Craft ad copy, visuals, landing pages, and content assets.", icon: Lightbulb },
  { number: "04", title: "Campaign Launch", description: "Deploy across selected channels with tracking and pixels in place.", icon: Rocket },
  { number: "05", title: "Monitor & Analyze", description: "Track performance metrics and identify optimization opportunities.", icon: BarChart3 },
  { number: "06", title: "Optimize & Scale", description: "Refine campaigns, A/B test, and scale what works best.", icon: RefreshCw },
];

const DmProcess: React.FC = () => (
  <AnimatedSection as="section" className="dm-section dm-section--light" aria-labelledby="dm-process-title">
    <div className="dm-container">
      <SectionHeader
        eyebrow="Our Process"
        title="How We Drive Your Digital Growth"
        text="A proven 6-step framework to launch, measure, and scale high-performing marketing campaigns."
        light
      />

      <div className="dm-process">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <motion.div
              key={step.title}
              className="dm-process__step"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
            >
              <div className="dm-process__badge">{step.number}</div>
              <div className="dm-process__icon">
                <Icon size={20} aria-hidden="true" />
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </AnimatedSection>
);

export default DmProcess;
